import { Button, Flex, Text } from '@tradener/lumen';

import useColorMode from '~/hooks/useColorMode';

import { NINEBOX_METRICS, NineBoxMetricProps } from './mockData';

interface NineBoxMetricRailProps {
  metric: NineBoxMetricProps;
  onMetricChange: (metric: NineBoxMetricProps) => void;
}

function NineBoxMetricRail({ metric, onMetricChange }: NineBoxMetricRailProps) {
  const metricButtonHeight = '2rem';
  const { colorTernary } = useColorMode();

  return (
    <Flex
      direction="column"
      width="5.5rem"
      minW="5.5rem"
      gap="2"
      m="0"
      flexShrink={0}
      justify="center"
      data-testid="ninebox-metric-filter"
    >
      {NINEBOX_METRICS.map((value) => {
        const isActive = value === metric;

        return (
          <Button
            key={value}
            borderRadius="full"
            width="full"
            minW="full"
            height={metricButtonHeight}
            minH={metricButtonHeight}
            variant="ghost"
            bg={isActive ? 'brand.500' : colorTernary('gray.100', 'gray.200')}
            px="4"
            py="2.5"
            display="flex"
            alignItems="center"
            justifyContent="center"
            aria-pressed={isActive}
            _hover={{ bg: isActive ? 'brand.600' : colorTernary('gray.200', 'gray.300') }}
            _active={{ bg: isActive ? 'brand.700' : colorTernary('gray.300', 'gray.400') }}
            onClick={() => onMetricChange(value)}
          >
            <Text
              as="span"
              textStyle="body2-regular"
              fontWeight="500"
              color={isActive ? 'white' : colorTernary('rgba(255,255,255,.9)', 'gray.800')}
              whiteSpace="nowrap"
              lineHeight="1"
              letterSpacing="0"
            >
              {value}
            </Text>
          </Button>
        );
      })}
    </Flex>
  );
}

export default NineBoxMetricRail;
